'use client';

import { LabelProviderRichText, labelProviderRichTextTag } from '@ni/nimble-components/dist/esm/label-provider/rich-text';
import { wrap } from '../../utilities/react-wrapper';

export { labelProviderRichTextTag };
export { type LabelProviderRichText };
export const NimbleLabelProviderRichText = wrap(LabelProviderRichText);
